(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tcc-fastpass-lottie]';

    const initialize = (root = document) => {
      if (!window.lottie) return;

      root.querySelectorAll(selector).forEach((container) => {
        if (container.dataset.lottieInitialized === 'true') return;

        const animationUrl = container.dataset.animationUrl;
        if (!animationUrl) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const animation = window.lottie.loadAnimation({
          container,
          renderer: 'svg',
          loop: !reduceMotion,
          autoplay: !reduceMotion,
          path: animationUrl,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
            progressiveLoad: true,
          },
        });

        container.dataset.lottieInitialized = 'true';
        container.tccFastpassAnimation = animation;

        if (reduceMotion) {
          animation.addEventListener('DOMLoaded', () => {
            animation.goToAndStop(0, true);
          });
        }
      });
    };

    if (document.readyState === 'complete') {
      initialize();
    } else {
      window.addEventListener('load', () => initialize(), { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((container) => {
        container.tccFastpassAnimation?.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcc-mystery-cash-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-tcc-money-lottie]';

    const initialize = (root = document) => {
      if (!window.lottie) return;

      root.querySelectorAll(selector).forEach((container) => {
        if (container.dataset.lottieInitialized === 'true') return;

        const animationUrl = container.dataset.animationUrl;
        if (!animationUrl) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const animation = window.lottie.loadAnimation({
          container,
          renderer: 'svg',
          loop: !reduceMotion,
          autoplay: !reduceMotion,
          path: animationUrl,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
            progressiveLoad: true,
          },
        });

        container.dataset.lottieInitialized = 'true';
        container.tccMoneyAnimation = animation;

        if (reduceMotion) {
          animation.addEventListener('DOMLoaded', () => {
            animation.goToAndStop(0, true);
          });
        }
      });
    };

    if (document.readyState === 'complete') {
      initialize();
    } else {
      window.addEventListener('load', () => initialize(), { once: true });
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(selector).forEach((container) => {
        container.tccMoneyAnimation?.destroy();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
